import ApplicationController from '../../frontend/support/application_controller'
import { disableElements, enableElements } from '../../frontend/support/helpers'

export default class extends ApplicationController {

  static targets = [
    'added',
    'notAdded',
    'body',
    'template',
    'input'
  ]

  static values = {
    added:   String,
    removed: String
  }

  static classes = [
    'hide'
  ]

  initialize() {}

  connect() {
    if (!this.addedTarget.classList.contains(this.hideClass)) {
      this.#enableBody()
    } else {
      this.#disableBody()
    }
  }

  // ==== Controllers

  // ==== Actions

  add() {
    this.addedTarget.classList.remove(this.hideClass)
    this.notAddedTarget.classList.add(this.hideClass)
    if (this.hasInputTarget) this.inputTarget.value = this.addedValue
    this.#enableBody()
  }

  remove() {
    this.addedTarget.classList.add(this.hideClass)
    this.notAddedTarget.classList.remove(this.hideClass)
    if (this.hasInputTarget) this.inputTarget.value = this.removedValue
    this.#disableBody()
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  #enableBody() {
    if (!this.hasBodyTarget) return

    enableElements(this.bodyTarget)
  }

  #disableBody() {
    if (!this.hasBodyTarget) return

    disableElements(this.bodyTarget)
  }

  // ==== Channels

}
